<script>
import UserIcon from "@src/assets/img/icons/pages/sales/user.svg";
import PhoneIcon from "@src/assets/img/icons/pages/sales/phone.svg";
import HashIcon from "@src/assets/img/icons/pages/sales/hash.svg";
import { formatPhone } from "@src/helpers/phone";
import { getSaleRole } from "@src/helpers/sale";
import Money from "@src/mixins/money";
import EmailIcon from "@src/components/ui-design/icons/EmailIcon.vue";

const PERCENT_TYPE_LABELS = Object.freeze({
  SELLER: "Taxa do Vendedor",
  CO_SELLER: "Participação",
  AFFILIATE: "Participação",
});

export default {
  mixins: [Money],
  components: {
    EmailIcon,
  },
  props: {
    seller: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      UserIcon,
      PhoneIcon,
      HashIcon,
      percentType: PERCENT_TYPE_LABELS,
    };
  },
  methods: {
    formatPhone,
    getSaleRole
  }
};
</script>

<template>
  <div class="sales-participations card-box p-3 px-0">
    <h6 class="sales-details__subtitle">
      <img :src="UserIcon" alt="Ícone de usuário" />
      {{ getSaleRole(seller.role) }}
    </h6>
    <div>
      <div class="mb-3">
        <div>Nome completo</div>
        <p class="sales-participations__text">{{ seller.name }}</p>
      </div>
      <div class="mb-3">
        <div>E-mail</div>
        <div class="sales-participations__text d-flex align-items-center">
          <EmailIcon class="mr-1" />
          <p>{{ seller.email }}</p>
        </div>
      </div>
      <div v-if="seller.role === 'SELLER'">
        <div class="mb-3">
          <div>Documento</div>
          <p class="sales-participations__text">{{ seller.cpf_cnpj }}</p>
        </div>
        <div class="mb-3">
          <div>Telefone</div>
          <p class="sales-participations__text d-flex align-items-center">
            <img class="mr-1" :src="PhoneIcon" alt="Ícone de telefone" />{{ formatPhone(seller.cellphone) }}
          </p>
        </div>
      </div>
    </div>
    <div class="mb-3" v-if="seller.role === 'AFFILIATE' || seller.role === 'CO_SELLER'">
      <p>ID</p>
      <p class="sales-participations__text d-flex align-items-center">
        <img class="mr-1" :src="HashIcon" alt="Ícone de ID" />{{ seller.id }}
      </p>
    </div>
    <div class="sales-details__bar"></div>
    <h6 class="sales-details__subtitle">{{ percentType[seller.role] || 'Taxa' }}:</h6>
    <div class="d-flex justify-content-between">
      <p>Valor: {{ (seller.userPercent || 0) * 100 }}%</p>
      <p class="sales-participations__money">R$ {{ seller.balance ?
        formatMoney(seller.balance) : '0,00' }}</p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.sales-participations {
  &__money {
    font-weight: 600;
    color: #000c0b;
  }

  &__text {
    color: #000c0b;
  }
}

img {
  width: 14px;
}
</style>
